export type TicketmasterCatalogFilters = {
  searchQuery: string;
  statusFilter: string;
  leagueFilter: string;
  artistsFilter: string;
  genresFilter: string;
};

/**
 * Builds Hasura `events_bool_exp` for Ticketmaster catalog list + aggregate count.
 */
export function buildTicketmasterEventsWhere(f: TicketmasterCatalogFilters): Record<string, unknown> {
  const conditions: Record<string, unknown>[] = [
    { e_platform_name: { _eq: "ticketmaster" } },
    { e_deleted_at: { _is_null: true } },
  ];

  const q = f.searchQuery.trim();
  if (q) {
    conditions.push({
      _or: [{ e_name: { _ilike: `%${q}%` } }, { e_stadium_name: { _ilike: `%${q}%` } }],
    });
  }

  if (f.statusFilter === "Active") {
    conditions.push({ e_status: { _in: ["on-sale", "onsale", "active"] } });
  } else if (f.statusFilter === "Deactivated") {
    conditions.push({
      e_status: {
        _in: [
          "offsale",
          "off-sale",
          "closed",
          "postponed",
          "cancelled",
          "date-tbd",
          "deactivated",
        ],
      },
    });
  } else if (f.statusFilter !== "All") {
    conditions.push({ e_status: { _eq: f.statusFilter } });
  }

  if (f.leagueFilter && f.leagueFilter !== "All Leagues") {
    conditions.push({
      event_categories: {
        ec_is_home: { _eq: true },
        league_category: { league: { l_name: { _ilike: f.leagueFilter } } },
      },
    });
  }

  if (f.artistsFilter && f.artistsFilter !== "All Artists") {
    conditions.push({ e_brand_name: { _ilike: f.artistsFilter } });
  }

  if (f.genresFilter === "Sports") {
    conditions.push({
      event_categories: {
        ec_is_home: { _eq: true },
        league_category: { league: { l_type: { _in: ["Sports", "OtherSports"] } } },
      },
    });
  } else if (f.genresFilter === "Music") {
    conditions.push({
      event_categories: {
        ec_is_home: { _eq: true },
        league_category: {
          league: {
            _and: [{ l_type: { _eq: "Entertainment" } }, { l_name: { _ilike: "%concerts%" } }],
          },
        },
      },
    });
  } else if (f.genresFilter === "Theater") {
    conditions.push({
      event_categories: {
        ec_is_home: { _eq: true },
        league_category: {
          league: {
            _and: [{ l_type: { _eq: "Entertainment" } }, { l_name: { _not: { _ilike: "%concerts%" } } }],
          },
        },
      },
    });
  }

  return { _and: conditions };
}
